import axios from 'axios';

type PageViewFbProps = {
  eventSourceUrl: string;
  eventId: string;
};

// Bate no proxy server-side (`/api/fb-capi`) — o token da Conversions API vive só no server.
//
// O `eventId` DEVE vir estável por intenção de page-view (mesma navegação → mesmo id).
// Quem chama é responsável por gerá-lo com `crypto.randomUUID()` no ponto onde a intenção
// nasce (ex: derivado de `useRouter().asPath` no effect que dispara o page-view). Se um hook
// re-executar por re-render ou o axios falhar e o caller tentar de novo, o id se repete e a
// Meta deduplica. Gerar dentro deste service, como estava, criaria id novo por chamada e
// duplicaria conversões no Events Manager.
const sendPageViewEventToFacebookAPI = async ({ eventSourceUrl, eventId }: PageViewFbProps) => {
  try {
    // Trailing slash é obrigatório: com `trailingSlash: true` no Next, `/api/fb-capi` (sem barra)
    // volta 301, e o browser converte POST→GET no redirect → evento nunca chega no handler.
    await axios.post(
      '/api/fb-capi/',
      { eventName: 'ViewContent', eventSourceUrl, eventId },
      { timeout: 3000 },
    );
  } catch {
    // fire-and-forget: falha silenciosa não pode atrapalhar a navegação
  }
};

export { sendPageViewEventToFacebookAPI };
